import {
    Message
} from 'element-ui';
var SYS_NAME = process.env.SYS_NAME;
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }
    messageInstance = Message(options)
};
['error','success','info','warning'].forEach(type => {
    resetMessage[type] = options => {
        if(typeof options === 'string') {
            let sysDuration=3000;
            if(SYS_NAME=='HR'){
                sysDuration=15000;
            }
            options = {
                message:options,
                duration:sysDuration
            }
        }
        options.type = type
        return resetMessage(options)
    }
})
export const resetMsg = resetMessage


// WEBPACK FOOTER //
// ./src/js/resetMessage.js